module.exports = __webpack_public_path__ + "static/media/artist_yhe-x_b.c984b6a5.png";